import React, { Suspense, lazy, useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Spinner from "../app/shared/Spinner";

import UserKyc from "./components/userManagement/UserKyc";
import Transactionhistory from "./components/transaction/Transactionhistory";

import Earings from "./dashboard/Earings";
import ComKyc from "./components/userManagement/ComKyc";
import SucWithdraw from "./components/transaction/SucWithdraw";
import RejectKyc from "./components/userManagement/RejectKyc";
import Completed from "./components/challengeManagement/Completed";
import Conflict from "./components/challengeManagement/Conflict";
import Cancelled from "./components/challengeManagement/Cancelled";
import Running from "./components/challengeManagement/Running";
import Pending from "./components/challengeManagement/Pending";
import New from "./components/challengeManagement/New";
import View from "./components/userManagement/View";
import Allhistory from "./components/userManagement/Allhistory";
import UpdatePassword from "./components/adminManagement/UpdatePassword";
import Permissions from "./components/agentManagement/Permissions";

import DepositReport from "./components/Reports/DepositReport";
import BonusReport from "./components/Reports/BonusReport";
import WithdrawalReport from "./components/Reports/WithdrawalReport";
import PenaltyReport from "./components/Reports/PenaltyReport";
import { Sitesettings } from "./components/adminManagement/Sitesettings";
import Notification from "./components/messaging/Notification";
import Bonus from "./components/transaction/bonus";
import BlockUser from "./components/Reports/BlockUser";
import DepositManual from "./components/transaction/DepositManual";
import AdminKyc from "./components/userManagement/adminKyc";
import Gateway from "./components/adminManagement/Gateway";
import BankDetails from "./components/adminManagement/BankDetails";
import { apiRequest } from "./apiServices/allApi";
import AgentData from "./components/adminManagement/AgentData";
import ClintPage from "./dashboard/clintPage";

// Admin Management
const Alladmin = lazy(() => import("./components/adminManagement/Alladmin"));
const Addadmin = lazy(() => import("./components/adminManagement/Addadmin"));

// User Management
const Allusers = lazy(() => import("./components/userManagement/Allusers"));
const Adduser = lazy(() => import("./components/userManagement/Adduser"));

// Challenge Management
const Allchallenges = lazy(
  () => import("./components/challengeManagement/Allchallenge"),
);
const Views = lazy(() => import("./components/challengeManagement/Views"));

// Transaction Management
const Allwithdrawl = lazy(() => import("./components/transaction/Withdrawl"));
const Penalty = lazy(() => import("./components/transaction/Penalty"));

const Dashboard = lazy(() => import("./dashboard/Dashboard"));
const Error404 = lazy(() => import("./shared/Error404"));
const Login = lazy(() => import("./shared/Login"));

const AppRoutes = () => {
  const access_token = localStorage.getItem("token");
  const [permissionsLoaded, setPermissionsLoaded] = useState(false);

  // --- Exact fields from AdminPermission model ---

  // 1. Dashboard & Earnings
  const [dashboard, setDashboard] = useState(false);
  const [earnings, setEarnings] = useState(false);

  // 2. Admin Manager
  const [allAdmins, setAllAdmins] = useState(false);
  const [newAdmin, setNewAdmin] = useState(false);
  const [adminKyc, setAdminKyc] = useState(false);
  const [sitesettings, setSitesettings] = useState(false);
  const [Gatewaysettings, setGatewaysettings] = useState(false);
  const [addBankDetail, setAddBankDetail] = useState(false);
  const [viewBankDetail, setViewBankDetail] = useState(false);
  const [allAgent, setAllAgent] = useState(false);

  // 3. User Manager
  const [allUsers, setAllUsers] = useState(false);
  const [pendingKyc, setPendingKyc] = useState(false);
  const [completedKyc, setCompletedKyc] = useState(false);
  const [rejectKyc, setRejectKyc] = useState(false);
  const [pushNotification, setPushNotification] = useState(false);
  const [legalData, setLegalData] = useState(false);

  // 4. Challenge Manager
  const [conflictChallenges, setConflictChallenges] = useState(false);
  const [pendingChallenges, setPendingChallenges] = useState(false);
  const [allChallenges, setAllChallenges] = useState(false);
  const [completedChallenges, setCompletedChallenges] = useState(false);
  const [cancelledChallenges, setCancelledChallenges] = useState(false);
  const [runningChallenges, setRunningChallenges] = useState(false);
  const [newChallenge, setNewChallenge] = useState(false);

  // 5. Transaction Manager
  const [allWithdrawlRequests, setAllWithdrawlRequests] = useState(false);
  const [depositManual, setDepositManual] = useState(false);
  const [depositHistory, setDepositHistory] = useState(false);
  const [bonus, setBonus] = useState(false);
  const [penalty, setPenalty] = useState(false);

  // 6. Reports
  const [bonusReport, setBonusReport] = useState(false);
  const [depositReport, setDepositReport] = useState(false);
  const [penaltyReport, setPenaltyReport] = useState(false);
  const [withdrawlReport, setWithdrawlReport] = useState(false);
  const [blockUser, setBlockUser] = useState(false);

  const apis = async () => {
    if (!access_token) {
      setPermissionsLoaded(true);
      return;
    }

    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`admin/me_data`, "GET", null, headers);

      if (
        res.data.user_type === "Admin" ||
        res.data.user_type === "Agent"
      ) {
        const p = res.data.permissions || {};
        setDashboard(Boolean(p.dashboard));
        setEarnings(Boolean(p.earnings));
        setAllAdmins(Boolean(p.allAdmins));
        setNewAdmin(Boolean(p.newAdmin));
        setAdminKyc(Boolean(p.adminKyc));
        setSitesettings(Boolean(p.sitesettings));
        setGatewaysettings(Boolean(p.Gatewaysettings));
        setAddBankDetail(Boolean(p.addBankDetail));
        setViewBankDetail(Boolean(p.viewBankDetail));
        setAllAgent(Boolean(p.allAgent));
        setAllUsers(Boolean(p.allUsers));
        setPendingKyc(Boolean(p.pendingKyc));
        setCompletedKyc(Boolean(p.completedKyc));
        setRejectKyc(Boolean(p.rejectKyc));
        setPushNotification(Boolean(p.pushNotification));
        setLegalData(Boolean(p.legalData));
        setConflictChallenges(Boolean(p.conflictChallenges));
        setPendingChallenges(Boolean(p.pendingChallenges));
        setAllChallenges(Boolean(p.allChallenges));
        setCompletedChallenges(Boolean(p.completedChallenges));
        setCancelledChallenges(Boolean(p.cancelledChallenges));
        setRunningChallenges(Boolean(p.runningChallenges));
        setNewChallenge(Boolean(p.newChallenge));
        setAllWithdrawlRequests(Boolean(p.allWithdrawlRequests));
        setDepositManual(Boolean(p.depositManual));
        setDepositHistory(Boolean(p.depositHistory));
        setBonus(Boolean(p.bonus));
        setPenalty(Boolean(p.penalty));
        setBonusReport(Boolean(p.bonusReport));
        setDepositReport(Boolean(p.depositReport));
        setPenaltyReport(Boolean(p.penaltyReport));
        setWithdrawlReport(Boolean(p.withdrawlReport));
        setBlockUser(Boolean(p.blockUser));
      }
    } catch (err) {
      if (err.response?.status === 401) {
        const errorMsg = String(
          err.response?.data?.msg || err.response?.data?.message || ""
        );
        if (!errorMsg.toLowerCase().includes("hmac")) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.assign("/adminlogin");
        }
      }
    } finally {
      setPermissionsLoaded(true);
    }
  };

  useEffect(() => {
    apis();
  }, [access_token]);

  if (!access_token) {
    return (
      <Suspense fallback={<Spinner />}>
        <Switch>
          <Route exact path="/adminlogin" component={Login} />
          <Redirect to="/adminlogin" />
        </Switch>
      </Suspense>
    );
  }

  if (!permissionsLoaded) {
    return null;
  }

  return (
    <>
      <Suspense fallback={<Spinner />}>
          <Switch>
            <Redirect exact from="/" to="/dashboard" />

            {/* 1. Dashboard & Earnings */}
            {dashboard && (
              <Route exact path="/dashboard" component={Dashboard} />
            )}
            {/* {earnings && (
              <Route exact path="/clintPage" component={ClintPage} />
            )} */}
            {earnings && <Route exact path="/earinigs" component={Earings} />}

            {/* 2. Admin Manager */}
            {allAdmins && (
              <Route path="/admin/alladmins" component={Alladmin} />
            )}
            {newAdmin && <Route path="/admin/addadmin" component={Addadmin} />}
            {adminKyc && <Route path="/user/adminkyc" component={AdminKyc} />}
            {sitesettings && (
              <Route path="/admin/sitesettings" component={Sitesettings} />
            )}
            {Gatewaysettings && (
              <Route path="/admin/getwaysettings" component={Gateway} />
            )}
            {(addBankDetail || viewBankDetail) && (
              <Route path="/admin/bankdetails" component={BankDetails} />
            )}
            {/* <Route path="/admin/update" component={UpdatePassword} /> */}
            <Route path="/agent/permissions/:id" component={Permissions} />
            {allAgent && (
              <Route
                path={["/Agent/Data/:id?", "/agent/data/:id?"]}
                component={AgentData}
              />
            )}

            {/* 3. User Manager */}
            {allUsers && <Route path="/user/allusers" component={Allusers} />}
            {pendingKyc && <Route path="/user/UserKyc" component={UserKyc} />}
            {completedKyc && <Route path="/user/kyc" component={ComKyc} />}
            {rejectKyc && <Route path="/user/reject" component={RejectKyc} />}
            {pushNotification && (
              <Route path="/user/notification" component={Notification} />
            )}
            <Route path="/user/adduser/:id" component={Adduser} />
            <Route path="/user/adduser" component={Adduser} />
            <Route path="/user/view_user/:id" component={View} />
            <Route path="/user/allhistory/:id" component={Allhistory} />

            {/* 4. Challenge Manager */}
            {conflictChallenges && (
              <Route
                path="/challenge/conflict_challange"
                component={Conflict}
              />
            )}
            {(pendingChallenges || runningChallenges) && (
              <Route path="/challenge/pending_challange" component={Pending} />
            )}
            {allChallenges && (
              <Route
                path="/challenge/allchallenges"
                component={Allchallenges}
              />
            )}
            {completedChallenges && (
              <Route
                path="/challenge/completed_challange"
                component={Completed}
              />
            )}
            {cancelledChallenges && (
              <Route
                path="/challenge/cancelled_challange"
                component={Cancelled}
              />
            )}
            {runningChallenges && (
              <Route path="/challenge/running_challange" component={Running} />
            )}
            {newChallenge && (
              <Route path="/challenge/new_challange" component={New} />
            )}
            <Route path="/view/:id" component={Views} />

            {/* 5. Transaction Manager */}
            {allWithdrawlRequests && (
              <Route
                path="/transaction/allwithdrawl"
                component={Allwithdrawl}
              />
            )}
            {depositManual && (
              <Route
                path="/transaction/deposit_manual"
                component={DepositManual}
              />
            )}
            {depositHistory && (
              <Route
                path="/transaction/transaction_history"
                component={Transactionhistory}
              />
            )}
            {allWithdrawlRequests && (
              <Route path="/transaction/withdraw" component={SucWithdraw} />
            )}
            {bonus && <Route path="/transaction/bonus" component={Bonus} />}
            {penalty && (
              <Route path="/transaction/penalty" component={Penalty} />
            )}

            {/* 6. Reports */}
            {bonusReport && (
              <Route path="/Reports/bonusReport" component={BonusReport} />
            )}
            {depositReport && (
              <Route path="/Reports/depositReport" component={DepositReport} />
            )}
            {penaltyReport && (
              <Route path="/Reports/penaltyReport" component={PenaltyReport} />
            )}
            {withdrawlReport && (
              <Route
                path="/Reports/withdrawalReport"
                component={WithdrawalReport}
              />
            )}
            {blockUser && (
              <Route path="/Reports/Blockuser" component={BlockUser} />
            )}

            {/* 7. Error 404 Fallback */}
            <Route path="/404" component={Error404} />
            <Route component={Error404} />
          </Switch>
      </Suspense>
    </>
  );
};

export default AppRoutes;
